export const LIST_SYSTEM_NOTICES = "notice/getall";
export const CREATE_SYSTEM_NOTICE = "notice/add";
export const UPDATE_SYSTEM_NOTICE = "notice/update";
export const GET_SYSTEM_NOTICE = (id) => `notice/get?id=${id}`;
export const DELETE_SYSTEM_NOTICE = (id) => `notice/delete?id=${id}`;

export const LIST_SYSTEM_NOTICES_FOR_CUSTOMER = "notice/getallvalid";
